import type { MeasureFormula as ApiMeasureFormula } from '../services/api/generated/model';
import { Formula } from './formula.interface';

export type ISODateTime = string;

/** Lifecycle of a measure_formula timeline segment (mirrors the backend enum). */
export enum MeasureFormulaStatus {
  ACTIVE = 1,
  SUSPENDED = 2,
}

export type MeasureFormula = Omit<ApiMeasureFormula, 'endTs' | 'suspendComment' | 'formula' | 'formulaId' | 'status'> & {
  name: string;
  endTs?: ISODateTime;
  suspendComment?: string;
  formula?: Formula | null;
  formulaId?: number | null;
  status: MeasureFormulaStatus;
  /** True iff a recorded value falls inside this segment's window. Always false for suspensions. */
  hasValues: boolean;
};
